module.exports = __webpack_public_path__ + "img/1499916486.a25e0b86.jpg";